import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4778a939"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "album__empty" }

import { useAlbumStore } from '@remote/store/album'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  data,
  refresh,
} = useAlbumStore()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["album__empty-img", { error: !!_unref(data).errorMsg }])
    }, null, 2),
    _createElementVNode("p", null, _toDisplayString(_unref(data).errorMsg || '暂无照片'), 1),
    _createElementVNode("p", {
      class: "album__empty-refresh",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(refresh) && _unref(refresh)(...args)))
    }, " 刷新 ")
  ]))
}
}

})